import FullName from "@repo/utils/FullName";
import Membership from "./Membership.js";
import Bookable from "./Bookable.js";
import Customer from "./Customer.js";
import PaymentMethod from "./PaymentMethod.js";
import { z } from "zod";
import { Promotion } from "./Promotion.js";

type Booking = {
  id: Booking.Id;
  bookableId: Bookable.Id;
  customerId: Customer.Id;
  confirmedAt: Date;
  status: "confirmed" | "cancelled";
  resourceId: Booking.Resource.Id;
  checkedInAt: Date;
};

namespace Booking {
  export type Id = `bg_${string}`;

  export namespace Id {
    export const is = (id: string | undefined | null): id is Id =>
      !!id?.startsWith("bg_");
  }

  export type Params = Pick<Booking, "bookableId" | "resourceId"> & {
    guestDetails?: Guest;
    promoCodeId?: Promotion.Code.Id;
  };

  export type Guest = {
    name: FullName;
    email: string;
  };

  export namespace Guest {
    export const zodSchema = () =>
      z.object({
        name: FullName.zodSchema(),
        email: z.string().email(),
      });
    export const isValid = (guest: Guest) =>
      zodSchema().safeParse(guest).success;
  }

  export type Resource =
    | Membership
    | PaymentMethod
    | Customer.ClassVoucherWallet
    | Customer.GuestPassWallet;
  export namespace Resource {
    export type Id = Resource["id"];
  }
}

export default Booking;
